module.exports = __webpack_public_path__ + "img/progressing-1.f3c5d94e.png";